export const INTEGRATIONS_CALLBACK_BASE_ROUTE = '/integrations-callback'
